import { render, staticRenderFns } from "./facture-soins.html?vue&type=template&id=3db187a0&scoped=true&external"
import script from "./facture-soins.js?vue&type=script&lang=js&external"
export * from "./facture-soins.js?vue&type=script&lang=js&external"
import style0 from "./facture-soins.scss?vue&type=style&index=0&id=3db187a0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db187a0",
  null
  
)

export default component.exports